import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { UserCategoryPage } from '@/features/users/pages/UserCategoryPage';

export const Route = createFileRoute('/_auth/users/marketing')({
  component: () => (
    <ErrorBoundary moduleName="Marketing Users">
      <Suspense fallback={<PageLoader />}>
        <UserCategoryPage category="marketing" />
      </Suspense>
    </ErrorBoundary>
  ),
});
